/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoicePersonLightResponse
 */
export interface InvoicePersonLightResponse {
    /**
     * the unique identifier of the person
     * @type {string}
     * @memberof InvoicePersonLightResponse
     */
    id?: string;
    /**
     * the firstname of the person
     * @type {string}
     * @memberof InvoicePersonLightResponse
     */
    firstName?: string;
    /**
     * the lastname of the person
     * @type {string}
     * @memberof InvoicePersonLightResponse
     */
    lastName?: string;
    /**
     * person has cns
     * @type {boolean}
     * @memberof InvoicePersonLightResponse
     */
    hasCns?: boolean;
    /**
     * CNS number
     * @type {string}
     * @memberof InvoicePersonLightResponse
     */
    cnsAffiliationNumber?: string;
}

/**
 * Check if a given object implements the InvoicePersonLightResponse interface.
 */
export function instanceOfInvoicePersonLightResponse(value: object): value is InvoicePersonLightResponse {
    return true;
}

export function InvoicePersonLightResponseFromJSON(json: any): InvoicePersonLightResponse {
    return InvoicePersonLightResponseFromJSONTyped(json, false);
}

export function InvoicePersonLightResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoicePersonLightResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'hasCns': json['hasCns'] == null ? undefined : json['hasCns'],
        'cnsAffiliationNumber': json['cnsAffiliationNumber'] == null ? undefined : json['cnsAffiliationNumber'],
    };
}

export function InvoicePersonLightResponseToJSON(json: any): InvoicePersonLightResponse {
    return InvoicePersonLightResponseToJSONTyped(json, false);
}

export function InvoicePersonLightResponseToJSONTyped(value?: InvoicePersonLightResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'hasCns': value['hasCns'],
        'cnsAffiliationNumber': value['cnsAffiliationNumber'],
    };
}

